import { Component, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";

@Component({
    template: ''
  })
export abstract class EditbaseComponent{

    @ViewChild('myForm') ngForm: NgForm;
  

    abstract save();    
    abstract delete();

}